export enum ChainId {
  SMARTBCH = 10000,
  SMARTBCH_AMBER = 10001
}
